import { BaseDeleteInputModel } from "../../../../../../../models/http/InputModel/BaseDeleteInputModel"

type MypageNovelNovelIdChapterChapterIdDeleteParams = {
  novelId: number
  chapterId: number
}

export class MypageNovelNovelIdChapterChapterIdDeleteInputModel extends BaseDeleteInputModel {
  constructor(private params: MypageNovelNovelIdChapterChapterIdDeleteParams) {
    super()
  }

  get pathParams() {
    return {
      novel_id: this.params.novelId.toString(),
      chapter_id: this.params.chapterId.toString(),
    }
  }
}
